import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { scAxiosAdmin, scAxios } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import RadioGroupFunctional from "../RadioGroupFunctional";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import thanas from "../../assets/data/thana.json";
import { error } from "jquery";
import banner_img from "../../images/banner-profile.jpg";
import cafeteria from "../../assets/data/cafeteria.json";
import Lightbox from "react-image-lightbox";
import menu from "../../assets/data/menu.json";
import Pagination from "react-js-pagination";

const Cafeteria = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2; // number of items to display per page
  const maxItems = 10;

  // Function to handle search term change
  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // reset current page when search term changes
  };

  // Filter the data based on the search term
  const filteredData = Object.entries(menu).reduce((result, [key, value]) => {
    const filteredItems = value.filter((item) =>
      item["Item Name"].toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (filteredItems.length > 0) {
      result.push({ key, items: filteredItems });
    }

    return result;
  }, []);

  // Get the current items to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const slicedData = filteredData.slice(0, maxItems); // limit the data to 10 items
  const currentItems = slicedData.slice(indexOfFirstItem, indexOfLastItem);

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleClickOnImage = (data) => {
    setIsOpen(true);
    setSelectedImage(data);
  };
  
  return (
    <div>
      <SEO
        title="Cafeteria | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Cafeteria"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="" style={{ backgroundColor: "#fef3e9" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <section className="termscondbody mt-5 pb-3">
          <div className="container p-3">
            <h2 className="text-secondary mb-3">Cafeteria</h2>
            <p className="text-secondary">
              Guest Cafeteria of United Hospital is open 24 hours every day. The
              Cafeteria offers hygienic and delicious meal options, including
              vegetarian choices, local and continental cuisine, salads, snacks,
              grills, ice-creams, milk shake, and fresh juices to retain our
              patients & guests a healthy mind. Breakfast, Lunch and Dinner
              including all the food items are made by In-house.
            </p>
          </div>
          <div className="container p-3">
            <h2 className="text-secondary mb-5">Gallery</h2>
            <div className="row w-100 mx-auto">
              <div className="container">
                <div
                  className="row g-4 pb-4"
                  style={{ backgroundColor: "#ffffff" }}
                >
                  {cafeteria.map((data, index) => (
                    <div className="col-12 col-md-4">
                      <div
                        key={index}
                        className="roomContainer"
                        onClick={() => handleClickOnImage(data.file)}
                      >
                        <a className="px-0 d-flex justify-content-center">
                          <img
                            style={{ width: "30vw", height: "30vh" }}
                            className="border"
                            src={require(`../../assets/images/Cafeteria/${data.file}.jpg`)}
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {isOpen && (
                <Lightbox
                  style={{ zIndex: "0" }}
                  mainSrc={require(`../../assets/images/Cafeteria/${selectedImage}.jpg`)}
                  onCloseRequest={() => setIsOpen(false)}
                ></Lightbox>
              )}
            </div>
          </div>
          <div className="container">
            <h2 className="text-secondary pt-5">Food Menu</h2>
            <div className="pt-3">
              <form
                className="d-flex mx-auto mb-3 align-items-center form-control"
                role="search"
              >
                <input
                  className="form-control me-2 "
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={handleSearchTermChange}
                  style={{ background: "transparent", border: "none" }}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </form>
              <table className="table table-striped table-hover mx-auto ">
                <tbody>
                  {currentItems.map((group, index) => (
                    <React.Fragment key={index}>
                      <tr className="table-dark">
                        <th colSpan={group.items.length}>{group.key}</th>
                      </tr>
                      {group.items.map((item, subIndex) => (
                        <tr key={subIndex}>
                          <td>{item["Item Name"]}</td>
                          <td>{item["Price (Taka)"]}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>

              <Pagination
                activePage={currentPage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={filteredData.length}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
              />
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Cafeteria;



// WEBPACK FOOTER //
// ./src/component/frontend/Cafeteria.js